
































import { BButton, BOverlay } from "bootstrap-vue";
// @ts-ignore
import { useRouter } from "@/@core/utils/utils";
import useEngageForm from "../useEngageForm";
import useCampaigns from "../useCampaigns";
import noEngageMessages from "./noEngageMessages.vue";
import engagePopover from "../components/engagePopover.vue";
import engageTable from "./engageTable.vue";
import { onMounted } from "@vue/composition-api";

export default {
    components: {
        BOverlay,
        BButton,
        noEngageMessages,
        engagePopover,
        engageTable,
    },
    setup() {
        const { router } = useRouter();
        const { clearData } = useEngageForm();
        const { campaigns, fetchCampaigns, isLoading, searchQuery, fetchLimit } = useCampaigns();

        fetchCampaigns();

        const onCreateNewEngage = () => {
            router.push({ name: "engage-create" });
            clearData();
        };

        onMounted(async () => {
            await fetchLimit();
        });

        return {
            onCreateNewEngage,
            clearData,
            isLoading,
            campaigns,
            searchQuery,
        };
    },
};
